module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root #home":{"storeLoader":[{"value":function () {
return new fox.RSVP.Promise(function (resolve) {
var pm = fox.site.wom1('@root .PermissionManager');
if (fox.getEnv('store.enabled') || !fox.isEmpty(pm.getMemberInfo('hasPurchasedProducts'))) {
return require.ensure([], function () {
return resolve(require('../components/store')(fox));
});
}
return resolve(true);
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101012},"path":"@root #home","_fox_":1}]},"~.Site_Page#storeList":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101014},"path":"~.Site_Page#storeList","_fox_":1}]},"~.Site_Page#purchasesList":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.Site_Page#purchasesList","_fox_":1}]},"~.Site_Page#storeItem":{"$requireResources":[{"value":"@root #home:storeLoader","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101018},"path":"~.Site_Page#storeItem","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/requireResources.js
// module id = 679
// module chunks = 4